import { createSlice } from "@reduxjs/toolkit";

export const ModalSlice = createSlice({
  name: "Modal",
  initialState: {
    add: false,
    edit: false,
    view: false,
    history: false,
    DeletePer: false,
    openAddModal: false,
    openEditModal: false,
    openViewModal: false,
    openHistoryModal: false,
    openDeletePerModal: false,
    val: [],
    val1: [],
    val3: [],
  },
  reducers: {
    rowValue: (state, action) => {
      state.val = action.payload;
    },
    rowValue1: (state, action) => {
      state.val1 = action.payload;
    },
    rowValueEmpty: (state, action) => {
      state.val1 = [];
    },
    handleAddOpen: (state) => {
      state.add = true;
    },
    handleAddClose: (state) => {
      state.add = false;
    },
    handleViewOpen: (state) => {
      state.view = true;
    },
    handleViewClose: (state) => {
      state.view = false;
    },
    handleEditOpen: (state) => {
      state.edit = true;
    },
    handleEditClose: (state) => {
      state.edit = false;
    },
    handleHistoryOpenModal: (state) => {
      state.openHistoryModal = true;
    },
    handleHistoryCloseModal: (state) => {
      state.openHistoryModal = false;
    },
    handleDeletePerOpen: (state) => {
      state.openDeletePerModal = true;
    },
    handleDeletePerClose: (state) => {
      state.openDeletePerModal = false;
    },
    handleOpenModal: (state) => {
      state.openAddModal = true;
    },
    handleCloseModal: (state) => {
      state.openAddModal = false;
    },
    handleEditOpenModal: (state) => {
      state.openEditModal = true;
    },
    handleEditCloseModal: (state) => {
      state.openEditModal = false;
    },
  },
});

export const {
  rowValue,
  rowValue1,
  rowValueEmpty,
  handleAddOpen,
  handleAddClose,
  handleEditOpen,
  handleEditClose,
  handleOpenModal,
  handleCloseModal,
  handleEditOpenModal,
  handleEditCloseModal,
  handleHistoryOpenModal,
  handleHistoryCloseModal,
  handleDeletePerOpen,
  handleDeletePerClose,
  handleViewClose,
  handleViewOpen,
} = ModalSlice.actions;

export default ModalSlice.reducer;
